<div *ngIf="showUrlShareables" class="marketing-page-share-url">
    <copy-short-url
        class="share-list-url"
        [buttonClass]="'button-share-link'"
        [shareOptions]="shareOptions">
    </copy-short-url>
</div>
